// WS-75: octahedral direction encodings (TSL), for trees.js.
//   octEncY / octDecY   whole sphere, y up (normals in the tree impostor atlases)
//   hemiEnc / hemiDec   upper hemisphere, y up (the impostor view grid)
// Inline Fn (no layout): each call is expanded where it is used, with its own variables.
import { Fn, float, vec2, vec3, abs, max, select, normalize } from 'three/tsl';

const l1 = (d) => max(abs(d.x).add(abs(d.y)).add(abs(d.z)), 1e-5);
const sgn2 = (a, b) => vec2(select(a.greaterThanEqual(0), 1, -1), select(b.greaterThanEqual(0), 1, -1));

export const octEncY = Fn(([n0]) => {
  const n = n0.div(l1(n0)).toVar();
  return select(n.y.lessThan(0), float(1).sub(abs(n.zx)).mul(sgn2(n.x, n.z)), n.xz);
});
export const octDecY = Fn(([p]) => {
  const n = vec3(p.x, float(1).sub(abs(p.x)).sub(abs(p.y)), p.y).toVar();
  const t = max(n.y.negate(), 0).toVar();
  return normalize(vec3(n.x.add(select(n.x.greaterThanEqual(0), t.negate(), t)), n.y, n.z.add(select(n.z.greaterThanEqual(0), t.negate(), t))));
});
export const hemiEnc = Fn(([d0]) => {
  const d = d0.div(l1(d0)).toVar();
  return vec2(d.x.add(d.z), d.x.sub(d.z));
});
export const hemiDec = Fn(([u]) => {
  const t = vec2(u.x.add(u.y), u.x.sub(u.y)).mul(0.5).toVar();
  return normalize(vec3(t.x, max(float(1).sub(abs(t.x)).sub(abs(t.y)), 0).add(1e-4), t.y));
});
